import { put, select, takeEvery } from 'redux-saga/effects';

import { softwareErrors } from 'dmpconnectjsapp-base/errors';
import { cardStatuses, dmpconnectMonitoringActionConstants } from '../constants';
import {
  getCpxCardStatus as getCpxCardStatusAccessor,
  isUserLoggedIn as isUserLoggedInAccessor,
} from '../helpers';


import { setModalError } from '../actions';
import { errorTypes } from '../errors/errorConfiguration';
import { createError, createModalError } from '../errors';

const handleCPXEvents = function* ({ data }) {
  const isLoggedIn = yield select(isUserLoggedInAccessor);
  const cpxCardStatus = yield select(getCpxCardStatusAccessor);
  const { message } = data;
  if (message !== undefined) {
    if (message.error) {
      const error = createError(
        errorTypes.SoftwareErrors,
        softwareErrors.DMPCONNECTJS_MISSING_OR_UNREACHABLE,
      );
      yield put(setModalError(createModalError(error)));
    }
    if (data.message.i_cardStatus === cardStatuses.NoCardInserted) {
      if (isLoggedIn || cpxCardStatus === 'OK') {
        yield put(setModalError({
          error: {
            i_apiErrorType: errorTypes.SoftwareErrors,
            i_apiErrorCode: softwareErrors.CPX_REMOVED,
          },
        }));
      }
    }
  }
};

export const handleCPXMonitoringUpdate = function* () {
  yield takeEvery(dmpconnectMonitoringActionConstants.DMPC_CPX_MONITORING_UPDATE, handleCPXEvents);
};
